var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import TimeUtils from '@business/utils/time';
import { AvailabilityCalendar } from '@data/models';
import { apiCall } from '../axios';
export class AvailabilityCalendarService {
    static search(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const calendar = yield apiCall(AvailabilityCalendar)('post', '/availability_calendar', params);
            calendar.checkin = TimeUtils.fromString(params.start_date);
            calendar.checkout = TimeUtils.fromString(params.end_date);
            calendar.code = params.promo_code || params.allotment_block_code || '';
            return calendar;
        });
    }
}
